"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Autocomplete = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const index_1 = require("../index");
require("./autocomplete.scss");
const Autocomplete = (props) => {
    const { className, children, ...inputProps } = props;
    const classNames = (0, classnames_1.default)('autocomplete', className !== null && className !== void 0 ? className : '');
    const [isActive, setIsActive] = (0, react_1.useState)(false);
    const mounted = (0, react_1.useRef)(false);
    // fixme не хочет так работать
    // const inputElement = useRef(inputProps.fieldRef);
    // const popperElement = useRef(null);
    //
    // const { styles, attributes } = usePopper(
    //     inputElement.current,
    //     popperElement.current,
    //     {
    //         placement: 'bottom-start',
    //         strategy: 'absolute',
    //         modifiers: [
    //             {
    //                 name: 'offset',
    //                 options: {
    //                     offset: [-29, 40]
    //                 },
    //             },
    //         ],
    //     },
    // );
    const propsOnFocus = inputProps.onFocus;
    const onFocus = (0, react_1.useCallback)((e) => {
        setIsActive(true);
        propsOnFocus === null || propsOnFocus === void 0 ? void 0 : propsOnFocus(e);
    }, [propsOnFocus]);
    const propsOnBlur = inputProps.onBlur;
    const onBlur = (0, react_1.useCallback)((e) => {
        setTimeout(() => {
            if (mounted.current)
                setIsActive(false);
        }, 250);
        propsOnBlur === null || propsOnBlur === void 0 ? void 0 : propsOnBlur(e);
    }, [propsOnBlur]);
    (0, react_1.useEffect)(() => {
        mounted.current = true;
        return () => {
            mounted.current = false;
        };
    }, []);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement(index_1.FormField, { onBlur: onBlur, onFocus: onFocus, className: 'autocomplete__input', onKeyPress: () => {
                setIsActive(true);
            }, ...inputProps }),
        isActive && children && (react_1.default.createElement("div", { className: 'autocomplete__dropdown' },
            react_1.default.createElement("div", { className: 'autocomplete__dropdown-content' }, children)))));
};
exports.Autocomplete = Autocomplete;
//# sourceMappingURL=Autocomplete.js.map